export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bonus-rules.vue?vue&type=template&id=33c2d861"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules.vue?vue&type=template&id=33c2d861
// module id = mTyJ
// module chunks = 0